/* eslint-disable max-len */
export const DUMMY_TABLE_DATA = [];
for (let i = 0; i < 10; i++) {
    DUMMY_TABLE_DATA.push({
        id: i + 1, column0: "00", column1: `cell 1_${i}`, column2: `cell 2_${i}`, column3: `cell 3_${i}`, column4: `cell 4_${i}`, column5: `cell 5_${i}`, column6: `cell 6_${i}`, column7: `cell 7_${i}`, column8: `cell 8_${i}`, column9: `cell 9_${i}`, column10: `cell 10_${i}`
    });
}
export const DUMMY_TABLE_COLUMNS = [{
    name: "deleteColumn", align: "center", label: "", field: "column0", visible: true
}];
for (let i = 0; i < 9; i++) {
    DUMMY_TABLE_COLUMNS.push({
        name: `column${i + 1}`, align: "center", label: "", field: `column${i + 1}`, visible: true
    });
}
